import { useLocation } from "react-router-dom";
import { TriangleAlert } from "lucide-react";
import { ADMIN_BASE } from "../lib/adminPath";

/**
 * Shown ONLY in the preview/dev environment, ONLY on admin pages.
 * Preview currently shares the LIVE production database (Atlas), so
 * destructive admin buttons here affect real orders/customers. The
 * banner never renders on the production domain (pepuralabs.ca) or
 * for shoppers.
 */
export const LiveDataBanner = () => {
  const { pathname } = useLocation();
  const host =
    typeof window !== "undefined" ? window.location.hostname : "";
  const isPreviewHost =
    host.endsWith(".emergentagent.com") ||
    host === "localhost" ||
    host === "127.0.0.1";
  if (!isPreviewHost) return null;
  if (!pathname.startsWith(ADMIN_BASE)) return null;
  return (
    <div
      data-testid="live-data-banner"
      className="sticky top-0 z-[60] flex items-center justify-center gap-2 border-b border-[#ff6b6b]/60 bg-[#3a0a0a] px-4 py-2 text-center"
    >
      <TriangleAlert size={16} className="shrink-0 text-[#ff9b9b]" />
      <p className="text-xs sm:text-sm font-semibold tracking-wide text-[#ffb4b4]">
        LIVE PRODUCTION DATA — this preview shares the real pepuralabs.ca
        database. Clearing, deleting or emailing here affects real
        customers and orders.
      </p>
    </div>
  );
};
